import axios from "axios";
import React from "react";
import { Link } from "react-router-dom";
import { Tab, Tabs } from 'react-bootstrap';
import Mailing from "./Mailing";
import Telephonique from "./Telephonique";
import SocialNet from "./SocialNet";
import Notified from "./Notified";
import Loader from "../../Loader";

class Table extends React.Component {
    state = {
        categorie: [],
        onglet: 'one',
        cvall: [],
        filteredCv: [],
        selectAllMail: false,
        allTelephone: false,
        allSocial: false,
        email: [],
        e_mail: '',
        cat_id: '0', // Initial value for all profiles
        loader: true
    }

    componentDidMount = () => {
        this.getCategorie();
        this.getCv();
    }

    getCategorie = () => {
        axios.get('categorie_cvs').then(resp => {
            if (resp.status === 200) {
                this.setState({
                    categorie: resp.data,
                    loader: false
                });
            }
        }).catch(error => console.log(error));
    }

    getCv = () => {
        axios.get('cvs').then(resp => {
            if (resp.status === 200) {
                this.setState({
                    cvall: resp.data,
                    filteredCv: resp.data,
                    loader: false
                });
            }
        }).catch(error => console.log(error));
    }

    handleOnglet = (e) => {
        this.setState({
            onglet: e
        });
    }

    handleSelectAllMail = () => {
        this.setState(prevState => ({
            selectAllMail: !prevState.selectAllMail
        }));
    }

    handleSelectTelephone = () => {
        this.setState(prevState => ({
            allTelephone: !prevState.allTelephone
        }));
    }

    handleSelectSocial = () => {
        this.setState(prevState => ({
            allSocial: !prevState.allSocial
        }));
    }

    handleEmail = (e) => {
        const mail = e.target.value;
        this.setState(prevState => ({
            email: prevState.email.filter(item => item.email !== mail)
        }));
    }

    handleSelectMontrer = (e) => {
        const selectedCategoryId = e.target.value;
        this.setState(prevState => {
            const filteredCv = selectedCategoryId === '0'
                ? prevState.cvall
                : prevState.cvall.filter(cv => cv.category_id === parseInt(selectedCategoryId));

            return {
                cat_id: selectedCategoryId,
                filteredCv: filteredCv
            };
        });
        console.log('Selected Category ID:', selectedCategoryId);
    }

    render() {
        const { categorie, filteredCv, loader, onglet, selectAllMail, allTelephone, allSocial, cat_id } = this.state;
        if (loader) {
            return <Loader />;
        }
        return (
            <>
                <div className="adminx-content">
                    <div className="adminx-main-content">
                        <div className="container-fluid">
                            <nav aria-label="chapelure" role="navigation">
                                <ol className="breadcrumb adminx-page-breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/">Accueil</Link></li>
                                    <li className="breadcrumb-item"><Link to="#">Interface utilisateur</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Gestion des requêtes des profils</li>
                                </ol>
                            </nav>

                            <div className="pb-3">
                                <h1>Liste des profils</h1>
                            </div>

                            <div className="row">
                                <div className="col-lg-8">
                                    <div className="card">
                                        <div className="card-header d-flex justify-content-between align-items-center">
                                            <div className="card-header-title">Gestion des requêtes des profils</div>
                                        </div>
                                        <div className="card-body collapse show" id="card1">
                                            <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                                                <div className="row">
                                                    <div className="col-sm-12 col-md-6">
                                                        <div className="dataTables_length" id="DataTables_Table_0_length">
                                                            <label>
                                                                Montrer &nbsp;
                                                                <select name="DataTables_Table_0_length" onChange={this.handleSelectMontrer} aria-controls="DataTables_Table_0" style={{ width: "200px" }} className="form-control form-control-sm">
                                                                    <option key="0" value="0">Tous les profils</option>
                                                                    {categorie && categorie.map(c => (
                                                                        <option key={c.id} value={c.id}>{c.categorie}</option>
                                                                    ))}
                                                                </select>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-12 col-md-6">
                                                        <div id="DataTables_Table_0_filter" className="dataTables_filter">
                                                            <label>
                                                                Rechercher :
                                                                <input type="search" className="form-control form-control-sm h31" placeholder="" aria-controls="DataTables_Table_0" />
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-12">
                                                        <br />
                                                        <Tabs className="nav nav-tabs" activeKey={onglet} onSelect={this.handleOnglet}>
                                                            <Tab eventKey="one" title="Notifier par e-mail">
                                                                <Mailing data={filteredCv} fun={this.handleSelectAllMail} check={selectAllMail} changeMail={this.handleEmail} CategoryId={cat_id} />
                                                            </Tab>
                                                            <Tab eventKey="two" title="Notifier par téléphone">
                                                                <Telephonique main={filteredCv} fon={this.handleSelectTelephone} checked={allTelephone} />
                                                            </Tab>
                                                            <Tab eventKey="three" title="Notifier par les réseaux sociaux">
                                                                <SocialNet meta={filteredCv} check={allSocial} fonction={this.handleSelectSocial} />
                                                            </Tab>
                                                        </Tabs>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4">
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="card-header-title">Notification</div>
                                        </div>
                                        <Notified status={onglet} mail={this.state.email} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Table;